// extracted by mini-css-extract-plugin
export default {"subtitle":"AddCustomersModal_subtitle__Jjkc-","formContainer":"AddCustomersModal_formContainer__IL8+B"};